import keys from './en.json';

/*
//TODO
function processRelativeTime(number, withoutSuffix, key, isFuture) {
  var format = {
    'm': ['one minute', 'einer Minute'],
    'h': ['eine Stunde', 'einer Stunde'],
    'd': ['ein Tag', 'einem Tag'],
    'dd': [number + ' Tage', number + ' Tagen'],
    'M': ['ein Monat', 'einem Monat'],
    'MM': [number + ' Monate', number + ' Monaten'],
    'y': ['ein Jahr', 'einem Jahr'],
    'yy': [number + ' Jahre', number + ' Jahren']
  };
  return withoutSuffix ? format[key][0] : format[key][1];
}
*/

export default {
  locale: 'en',
  messages: {
    ...keys,
    'RoundDateDisplay::format': `{ hasEnd, select,
      true {
        { preposition, select,
          at { at { end } }
          until { until { end } }
        }
      }
      other { { duration, plural,
          one { # Day }
          other { # Days }
        }
      }
    }`,
    statusvalue: `{ whitelistedAgentStatus, select,
      requested { Participation requested }
      blocked { Access blocked }
      other {

        { roundNumber, select,
          0 {
            { content, select,
              Preview { Preview }
              Resolved { Resolved }
              other { {content} }
            }
          }
          other {
            { roundType, select,
              counteroffer_bidding { Counteroffer }
              incremental_auction { Flexible }
              live_auction { Live Auction }
              open_bidding { Open }
              registration { Registration }
              sealed_bidding { Sealed }
              simple_offer { Digital offer }
            }
            round
            { roundNumber }
            { roundStatus, select,
              opened { opened }
              started { started }
              closed { closed }
              other { {roundStatus} }
            }
          }
        }
      }
    }`,
    'RoundInfo::label': `
      { type, select,
        sealed_bidding { Sealed }
        open_bidding { Open }
        incremental_auction { Flexible }
        live_auction { Live Auction }
        counteroffer_bidding { Counteroffer }
        registration { Registration }
        simple_offer { Simple Offer }
      }
      round
      { number }
      { status, select,
        started { not yet opened }
        opened
        {
          { hasEnd, select,
            true {
              { durationType, select,
                  fixed {
                    { isPreview, select,
                      true { starts {startDuration} }
                      false {
                        { isPast, select,
                          false { ends {endDuration} }
                          other { past }
                        }
                      }
                    }
                  }
                  flexible { in {durationInDays} days }
              }
            }
            other { }
          }
        }
        closed { closed on { endText } }
        other { {status} }
      }
    `,
  },

  moment: {
    months:
      'January_February_March_April_May_June_July_August_September_October_November_December'.split(
        '_'
      ),
    monthsShort:
      'Jan._Feb._Mar._Apr._May_Jun._Jul._Aug._Sep._Oct._Nov._Dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
      '_'
    ),
    weekdaysShort: 'Su._Mo._Tu._We._Th._Fr._Sa.'.split('_'),
    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD.MM.YYYY',
      LL: 'D. MMMM YYYY',
      LLL: 'D. MMMM YYYY HH:mm',
      LLLL: 'dddd, D. MMMM YYYY HH:mm',
    },
    calendar: {
      sameDay: "[today at] LT [O'Clock]",
      sameElse: 'L',
      nextDay: "[tomorrow at] LT [O'Clock]",
      nextWeek: "dddd [at] LT [O'Clock]",
      lastDay: "[yesterday at] LT [O'Clock]",
      lastWeek: "[last] dddd [at] LT [O'Clock]",
    },
    /*
    //TODO
    relativeTime: {
      future: 'in %s',
      past: 'past %s',
      s: 'a few seconds',
      ss: '%d seconds',
      m: processRelativeTime,
      mm: '%d minutes',
      h: processRelativeTime,
      hh: '%d hours',
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    */
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/locales/en.js